import { Ass_03, Exp_01, Lia_01 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const INCOMING_NO_VAT_INVOICE: Template = {
  id: "a8533358-e896-4675-8a28-c7481a268030",
  name: "Sissetulev arve KM-ta",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Invoice date",
      type: "date"
    },
    {
      name: "Payment date",
      type: "date"
    },
    {
      name: "Expense amount",
      type: "amount_eur"
    }
  ],
  generate: (values) => {
    const invoiceDate = findVariableValue("Invoice date", values);
    const paymentDate = findVariableValue("Payment date", values);

    const expenseAmount = Math.round(parseFloat(findVariableValue("Expense amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Arve summa",
          date: invoiceDate,
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Exp_01,
          credit: Lia_01
        },
        {
          title: "Arve tasumine",
          date: paymentDate,
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Lia_01,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
